/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-11-02 16:35:58
 * @LastEditors: Li Yong
 * @LastEditTime: 2022-04-08 11:22:00
 */
import mixin from '@/mixins';
export default {
	mixins: [mixin],
	methods: {
		// 检测是否绑定微信
		checkHasBindWx(openIds) {
			const hasBindMiniPrograme = openIds?.find(item => item.type == 32 && item.openId);
			return hasBindMiniPrograme;
		},
		// 如果未绑定微信跳转绑定页面，否则跳转工作台页面
		gotoIndex(openIds) {
			const path = !this.checkHasBindWx(openIds) ? '/bind' : '/';
			this.$router.replace(path);
		},
		// 商团协作如果未绑定微信跳转绑定页面，否则跳转商品库
		gotoGoods(openIds) {
			const path = !this.checkHasBindWx(openIds) ? '/bind' : '/shopManage/shopLibrary/list';
			this.$router.replace(path);
		},
	},
};
